// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qOYQsbJzks5mNw {
  position: relative;
  width: 64px;
  height: 64px;
  margin: var(--ds-space-075, 6px);
  cursor: grab;
}
.JAsU303yiWOHte {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 32px 64px 0);
}
.JAsU303yiWOHte[data-drag-preview] {
  position: static;
  clip: auto;
  backface-visibility: visible;
}
.p47huoWvRx4uuI {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 64px 64px 32px);
  transform: scaleX(1) skewY(0deg);
  transition: transform 0.25s ease;
  opacity: 0.1;
  filter: brightness(0);
}
.ulqDwnc4ZUK6pf .p47huoWvRx4uuI {
  transform: scaleX(0.95) skewY(8deg);
}
.OIpiko2gYn7bu2 {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  backface-visibility: hidden;
  clip: rect(0 64px 64px 32px);
  transform: perspective(300px);
  transform-style: preserve-3d;
  transition: transform 0.2s ease;
}
.ulqDwnc4ZUK6pf .OIpiko2gYn7bu2 {
  transform: perspective(300px) rotateY(-50deg);
}
`, ""]);
// Exports
export var sticker = `qOYQsbJzks5mNw`;
export var fixed = `JAsU303yiWOHte`;
export var shadow = `p47huoWvRx4uuI`;
export var isPeeling = `ulqDwnc4ZUK6pf`;
export var peel = `OIpiko2gYn7bu2`;
export default ___CSS_LOADER_EXPORT___;
